import React from 'react'

export interface SectionHeaderProps {
  title: string
  subtitle?: string
  /** Right-aligned controls: a period picker, a filter, a link. */
  action?: React.ReactNode
  className?: string
}

/**
 * The heading above a band of cards.
 *
 * `items-end` so a tall control on the right sits on the same baseline as the
 * title, and `flex-wrap` so the controls drop under the heading on a phone
 * instead of squeezing it.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  action,
  className = '',
}) => (
  <div className={`flex items-end justify-between gap-4 flex-wrap ${className}`}>
    <div className="flex flex-col gap-0.5">
      <h2 className="text-base font-semibold text-dashboard-text font-poppins">{title}</h2>
      {subtitle && <span className="text-xs text-dashboard-muted font-poppins">{subtitle}</span>}
    </div>
    {action}
  </div>
)
